<template>
  <div class="edit-form-list-item">
    <div class="history-item">
      <div class="history-item-button">
        <div class="button">
          <el-button :disabled="!(index > 0 && length > 1)" icon="el-icon-arrow-up" circle
            @click.stop="handleCommand('moveUp')"></el-button>
        </div>
        <div class="button">
          <el-button :disabled="!(index + 1 != length && length > 1)" icon="el-icon-arrow-down" circle
            @click.stop="handleCommand('moveDown')"></el-button>
        </div>
      </div>
      <div class="history-item-content">
        <el-form class="history-form" ref="historyItemForm" :model="item" :rules="rules" @submit.native.prevent>

          <el-form-item prop="companyName" class="edit-form-item">
            <div class="item-name"><label for="companyName">会社名</label></div>
            <el-input class="input-lg" type="textbox" id="companyName" :autosize="{ minRows: 1, maxRows: 4 }"
              :placeholder="descriptionPlaceholder" v-model="item.companyName" ref="desc"></el-input>
          </el-form-item>

          <div class="edit-form-item">
            <div class="item-name"><label>在籍期間</label></div>
            <div class="period-start">
              <div class="form-date">
                <el-form-item label="" prop="startYear">
                  <el-input class="input-xxs" placeholder="2000" title="年" v-model="item.startYear" type="number"
                    :min="computedMinYear" :max="computedMaxYear" ref="year">
                  </el-input>
                  <span>年</span>
                </el-form-item>
                <el-form-item label="" prop="startMonth">
                  <el-input class="input-xxs input-2-digit" placeholder="12" title="月" v-model="item.startMonth"
                    type="number" min="1" max="12" ref="month">
                  </el-input>
                  <span class="unit">月から</span>
                </el-form-item>
              </div>
            </div>
            <div class="period-end">
              <div class="form-date">
                <el-form-item label="" prop="endYear">
                  <el-input class="input-xxs" placeholder="2000" title="年" v-model="item.endYear" type="number"
                    :min="computedMinYear" :max="computedMaxYear" ref="year" :disabled="item.isContinuing">
                  </el-input>
                  <span class="unit">年</span>
                </el-form-item>
                <el-form-item label="" prop="endMonth">
                  <el-input class="input-xxs input-2-digit" placeholder="12" title="月" v-model="item.endMonth"
                    type="number" min="1" max="12" ref="month" :disabled="item.isContinuing">
                  </el-input>
                  <span>月まで</span>
                  <el-checkbox v-model="item.isContinuing" @change="changeCheckbox">在職中</el-checkbox>
                </el-form-item>
              </div>
            </div>
          </div>

          <!-- 詳細格納時にプロジェクト名だけ表示 -->
          <div class="projects" :class="{ 'project__invisible': isActive() == true }">
            <ul v-for="(item, index) in item.projects" :key="index">
              <li v-if="item.projectTitle == ''">プロジェクト・業務が未入力です</li>
              <li v-else>{{ item.projectTitle }}</li>
            </ul>
          </div>

          <div class="errors" v-if="errors">
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div class="enter text-right">
            <!-- <el-button icon="el-icon-plus" -->
            <!-- @click.stop="$eventHub.$emit('add-history-item-detail')">add</el-button> -->
          </div>
        </el-form>
      </div>
    </div>

    <!-- :class="{ 'detail__visible': this.activeHistoryItem != this.item.uuid}" -->
    <div class="projects" :class="{ 'project__invisible': isActive() == false }">
      <transition-group tag="div" name="list">
        <div class="project-item" @click.native="activateItem(item2)" v-for="(item2, index2) in item.projects"
          :index2="index2" :key="item2.uuid">
          <!-- <div class="history-item-button showButton"> -->
          <div class="showButton text-right project-item-button">
            <div class="button">
              <el-button :disabled="!(index2 > 0 && item.projects.length > 1)" icon="el-icon-arrow-up" circle
                @click.stop="moveUpDetail(index2)"></el-button>
            </div>
            <div class="button">
              <el-button :disabled="!(index2 + 1 != item.projects.length && item.projects.length > 1)"
                icon="el-icon-arrow-down" circle @click.stop="moveDownDetail(index2)"></el-button>
            </div>
          </div>
          <div class="project-item-content">
            <el-form class="history-form edit-form-item">
              <div class="item-name"><label for="projectTitle">プロジェクトまたは業務名</label></div>
              <el-form-item prop="projectTitle">
                <el-input class="input-lg" type="textbox" id="projectTitle" :autosize="{ minRows: 1, maxRows: 4 }"
                  placeholder="プロジェクトまたは業務名" v-model="item2.projectTitle" ref="desc">
                </el-input>
                <span></span>
              </el-form-item>

              <div class="item-name"><label for="">期間</label></div>
              <div class="form-date">
                <el-form-item prop="startYear">
                  <el-input class="input-xxs" placeholder="2000" title="年" v-model="item2.startYear" type="number"
                    :min="computedMinYear" :max="computedMaxYear" ref="year">
                  </el-input>
                  <span>年</span>
                </el-form-item>
                <el-form-item prop="startMonth">
                  <el-input class="input-xxs input-2-digit" placeholder="12" title="月" v-model="item2.startMonth"
                    type="number" min="1" max="12" ref="month">
                  </el-input>
                  <span>月から</span>
                </el-form-item>
              </div>
              <div class="form-date">
                <el-form-item prop="endYear">
                  <el-input class="input-xxs" placeholder="2000" title="年" v-model="item2.endYear" type="number"
                    :min="computedMinYear" :max="computedMaxYear" ref="year">
                  </el-input>
                  <span>年</span>
                </el-form-item>
                <el-form-item prop="endMonth">
                  <el-input class="input-xxs input-2-digit" placeholder="12" title="月" v-model="item2.endMonth"
                    type="number" min="1" max="12" ref="month">
                  </el-input>
                  <span>月まで</span>
                </el-form-item>
              </div>
              <el-form-item prop="contentsOfProject">
                <div class="item-name"><label for="contentsOfProject">プロジェクトや業務内容の説明</label></div>
                <el-input class="input-lg" type="textarea" id="contentsOfProject" :autosize="{ minRows: 6, maxRows: 8 }"
                  placeholder="業務内容やプロジェクトの説明" v-model="item2.contentsOfProject" ref="desc">
                </el-input>
                <span></span>
              </el-form-item>

              <el-form-item prop="dev">
                <div class="item-name"><label for="dev">環境・言語</label></div>
                <el-input class="input-md" type="textbox" id="dev" placeholder="HTML、CSS" v-model="item2.dev"
                  ref="desc">
                </el-input>
                <span></span>
              </el-form-item>

              <el-form-item prop="position">
                <div class="item-name"><label for="position">役割・役職</label></div>
                <el-input class="input-md" type="textbox" id="position" placeholder="役職" v-model="item2.position"
                  ref="desc">
                </el-input>
                <span></span>
              </el-form-item>

              <el-form-item prop="numberOfTeam" class="edit-form-item">
                <div class="item-name"><label for="numberOfTeam">規模・人数</label></div>
                <el-input class="input-sm" type="textbox" id="numberOfTeam" placeholder="メンバー数"
                  v-model="item2.numberOfTeam" ref="desc">
                </el-input>
                <span class="unit">名</span>
              </el-form-item>

              <el-form-item prop="phase" class="edit-form-item">
                <div class="item-name"><label for="phase">担当工程</label></div>
                <div class="phase-checkbox">
                  <label><el-checkbox class="input-sm" id="phase" v-model="item2.phase1"
                      style="margin-right: 15px;">要件定義</el-checkbox></label>
                  <label><el-checkbox class="input-sm" id="phase" v-model="item2.phase2"
                      style="margin-right: 15px;">基本設計</el-checkbox></label>
                  <label><el-checkbox class="input-sm" id="phase" v-model="item2.phase3"
                      style="margin-right: 15px;">詳細設計</el-checkbox></label>
                  <label><el-checkbox class="input-sm" id="phase" v-model="item2.phase4"
                      style="margin-right: 15px;">実装・単体</el-checkbox></label>
                  <label><el-checkbox class="input-sm" id="phase" v-model="item2.phase5"
                      style="margin-right: 15px;">結合テスト</el-checkbox></label>
                  <label><el-checkbox class="input-sm" id="phase" v-model="item2.phase6">保守・運用</el-checkbox></label>
                </div>
              </el-form-item>

              <div class="enter">
                <el-button icon="el-icon-delete" type="text" size="small"
                  @click.stop="deleteDetail(index2)">このプロジェクト・実績を削除</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </transition-group>
      <div class="add-project-item enter">
        <el-button icon="el-icon-plus" @click.stop="handleCommand('addProject')">参加プロジェクト・実績を追加</el-button>
      </div>
      <div class="add-project-item enter">
        <el-button icon="el-icon-delete" @click.stop="handleCommand('delete')">削除</el-button>
        <el-button icon="el-icon-check" @click.stop="$eventHub.$emit('deactivate-history-item')">OK</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    length: {
      type: Number
    },
    descriptionPlaceholder: {
      type: String
    },
    descriptionMaxLength: {
      type: Number
    },
    minYear: {
      type: [Number, String]
    },
    maxYear: {
      type: [Number, String]
    },
    activeHistoryItem: {
      type: String
    }
  },
  data: function () {
    const app = this
    const validateYear = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 6) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateMonth = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 4) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateDescription = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > app.descriptionMaxLength) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    return {
      errors: [],
      rules: {
        year: [
          {
            validator: validateYear,
            message: '年が長すぎます',
            trigger: ['change', 'blur']
          }
        ],
        month: [
          {
            validator: validateMonth,
            message: '月が長すぎます',
            trigger: ['change', 'blur']
          }
        ],
        description: [
          {
            validator: validateDescription,
            message: '一行におさまる文字数をオーバーしています。文章を短くするか、行を ＋ で追加して入力してください。',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  computed: {
    computedMinYear: function () {
      if (this.minYear) {
        return Number(this.minYear)
      }
      return 1980
    },
    computedMaxYear: function () {
      if (this.maxYear) {
        return Number(this.maxYear)
      }
      return new Date().getFullYear()
    }
  },
  methods: {
    handleCommand: function (command) {
      if (command === 'addAbove') {
        this.$emit('add-history-item', this.index)
      } else if (command === 'addBelow') {
        this.$emit('add-history-item', this.index + 1)
      } else if (command === 'delete') {
        this.$emit('delete-history-item', this.index)
      } else if (command === 'duplicate') {
        this.$emit('add-history-item', this.index, this.item)
      } else if (command === 'moveUp') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'up'
        })
      } else if (command === 'moveDown') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'down'
        })
      } else if (command === 'addProject') {
        this.$emit('add-project-history-item', this.index, this.item)
      }
    },
    isActive: function () {
      if (this.activeHistoryItem === this.item.uuid) {
        return true
      } else {
        return false
      }
    },
    activateItem: function (id) {
      console.log(id)
    },
    deleteDetail: function (index2) {
      this.$emit('delete-history-item-detail', this.index, index2)
    },
    moveUpDetail: function (index2) {
      this.$emit('move-history-item-detail', {
        index: index2,
        to: 'up'
      }
      , this.index)
    },
    moveDownDetail: function (index2) {
      this.$emit('move-history-item-detail', {
        index: index2,
        to: 'down'
      }
      , this.index)
    },
    resizeDesc: function () {
      const app = this
      this.$nextTick(function () {
        if (typeof app.$refs.desc.resizeTextarea === 'function') {
          if (app.$refs.desc.$el.offsetHeight) {
            app.$refs.desc.resizeTextarea()
          }
        }
      })
    },
    changeCheckbox: function () {
      if (this.item.isContinuing) {
        this.item.endYear = ''
        this.item.endMonth = ''
      }
    }
  },
  watch: {
    item: function (newVal) {
      console.log(newVal)
    }
  },
  beforeMount: function () {
    this.$nextTick(function () {
      // 初回読み込み時にバリデーションを動かす
      this.$refs.historyItemForm.validate().then().catch(function (e) {
        // console.error(e)
      })
    })
  },
  mounted: function () {
    this.$eventHub.$on('card-changed', this.resizeDesc)
  },
  destroyed: function () {
    this.$eventHub.$off('card-changed', this.resizeDesc)
  }
}
</script>
<style lang="scss" scoped>
$white: #fff;
$basecolor: #f8f8f8;
$light-gray: #dcdfe6;
$errorcolor: #f56c6c;

/* .projects { */
/* background-color:rgba(246,247,249,0.8); */
/* } */
.project__invisible {
  display: none;
}

.project__invisible2 {
  display: none;
}

.edit-form-list-item {
  &.active {
    .project-item {
      border-top: dashed 1px $light-gray;
      padding: 1rem 0;

      .enter {
        margin-top: .5rem;
      }
    }
  }
}

.history-item {
  display: flex;
  flex-direction: row-reverse;
}

.history-item-content {
  flex: 1;
  margin: .5rem 0;
  padding: .5rem 1rem;

  .attention-limit {
    font-size: .75rem;
    color: $errorcolor;

    &.character {
      padding: .5rem 0;
    }

    &.column {
      background: $white;
      margin: .5rem 0;
      padding: .5rem 1rem;
    }
  }
}

/* 詳細を隠す時に上下ボタンが高さを確保してしまうので修正 */
/* buttonにdisplay: flex; 追加 */
.history-item-button {
  .button {
    display: flex;

    button {
      &.is-disabled {}
    }
  }
}

.projects {
  margin-top: .5rem;

  >ul {
    list-style: none;
    // list-style-position: inside;
    font-size: .75rem;

    li {
      &::before {
        content: "";
        display: inline-block;
        background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OTYgNDk2Ij48Zz48cGF0aCBkPSJNMjQ4LDBDMTExLDAsMCwxMTEsMCwyNDhTMTExLDQ5NiwyNDgsNDk2LDQ5NiwzODUsNDk2LDI0OCwzODUsMCwyNDgsMFpNNDAzLjMxLDE5NS4zMWwtMTg0LDE4NGgwYTE2LDE2LDAsMCwxLTIyLjYyLDBsLTEwNC0xMDRhMTYsMTYsMCwwLDEsMC0yMi42MmwyMi42Mi0yMi42M2ExNiwxNiwwLDAsMSwyMi42MywwTDIwOCwzMDAuMTIsMzU4LjA2LDE1MC4wNmExNiwxNiwwLDAsMSwyMi42MywwbDIyLjYyLDIyLjYzQTE2LDE2LDAsMCwxLDQwMy4zMSwxOTUuMzFaIi8+PC9nPjwvc3ZnPg==");
        margin-right: .25rem;
        width: .75rem;
        height: .75rem;
      }
    }
  }

  /* background-color: $basecolor; */
}

.project-item {
  display: flex;
  flex-direction: row-reverse;
  /* background: #f2f2f2; */
}

.project-item-button {
  display: flex;
  flex-direction: column;
  width: 3.5rem;

  // border-bottom: solid 1px darken($basecolor, 5);
  .button {
    flex: 1;

    button {
      height: 100%;
      border-radius: 0;
      border: none;

      &.is-disabled {
        color: darken($basecolor, 5);
      }
    }
  }
}

.project-item-content {
  flex: 1;
  margin: .5rem 0;
  padding: .5rem 1rem;

  .attention-limit {
    font-size: .75rem;
    color: $errorcolor;

    &.character {
      padding: .5rem 0;
    }

    &.column {
      background: $white;
      margin: .5rem 0;
      padding: .5rem 1rem;
    }
  }
}

.add-project-item {
  border-top: dashed 1px $light-gray;
  padding: 1rem;
  text-align: right;
}

.showButton {}

.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter-to {}

.list-enter-active,
.list-leave-active {}

.list-enter,
.list-leave {
  /* opacity: 0; */
  /* transform: translateX(50px) scaleY(0.5); */
}
</style>
